import { ButtonHeading, CommonInput, CommonModal } from "components";
import React from "react";
import {
  deleteUserData,
  getUserDetails,
  toggleUserActiveStatus,
} from "../../_services/userService";
import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Images } from "constants";
import { FaCheckCircle } from "react-icons/fa";
import { FaMedal } from "react-icons/fa6";
import {
  addSifarishPoints,
  getExportForwardedSifarish,
  getExportReportedSifarish,
  getExportSavedSifarish,
  getUserCompleteSifarishData,
  getUserSifarishAll,
} from "_services";
import { EditUserProfile } from "modals";
import { MdCancel } from "react-icons/md";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const UserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storageBird, listData, currentIndex } = location.state || {};
  const [activeIndex, setActiveIndex] = useState(currentIndex ?? 0);
  const { id } = useParams();
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const [UserData, setUserData] = useState();
  const [sifarishData, setSifarishData] = useState();
  const [userToEdit, setUserToEdit] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [formValue, setFormValue] = useState({
    points: "",
  });

  useEffect(() => {
    if (listData && listData[activeIndex]) {
      fetchUserData(listData[activeIndex]._id);
    } else if (id) {
      fetchUserData(id);
    }
  }, [activeIndex, id, listData]);

  useEffect(() => {
    fetchUserSifarish();
  }, []);

  const fetchUserData = async (userIdToFetch) => {
    try {
      const payload = {
        userId: getUserData?._id,
        userIdToRetrive: userIdToFetch,
      };

      const res = await getUserDetails(payload);

      if (res) {
        setUserData(res?.data);
      } else {
        toast.error(res?.responseMessage || "Failed to fetch user");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const fetchUserSifarish = async (data) => {
    try {
      const payload = {
        userId: getUserData?._id,
        createdByUserId: id,
      };

      const res = await getUserSifarishAll(payload);
      if (res) {
        setSifarishData(res?.data);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const fetchToggleUserStatus = async (targetUserId) => {
    try {
      if (targetUserId === getUserData?._id) {
        toast.error("You cannot change your own status");
        return;
      }

      const payload = {
        userId: getUserData?._id,
        userIdToDelete: targetUserId,
      };

      const res = await toggleUserActiveStatus(payload);

      if (res?.message) {
        toast.success(res?.message);

        fetchUserData();
      } else {
        toast.error(res?.responseMessage || "Failed to update status");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const navigateOnSifarish = () => {
    if (sifarishData?.sifarishes[0]?.createdByUserId?._id) {
      navigate("/sifarish", {
        state: {
          userId: getUserData?._id,
          createdByUserId: sifarishData?.sifarishes[0]?.createdByUserId?._id,
          firstName: UserData?.firstName,
          lastName: UserData?.lastName,
        },
      });
    } else {
      toast.error(
        `No Sifarish avilable for ${UserData?.firstName} ${UserData?.lastName}`
      );
    }
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      userIdToDelete: isDelete?._id,
    };
    try {
      const res = await deleteUserData(payload);
      if (res) {
        setIsDelete(false);
        navigate("/user");
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const navigateOnSession = () => {
    navigate(`/session`, { state: UserData });
  };

  const navigateOnContact = () => {
    navigate(`/contact`, { state: UserData });
  };

  const navigateOnSifarishPoint = () => {
    navigate(`/sifarish_points`, { state: UserData });
  };

  const EditUserModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit User",
    footerPart: true,
    submitTitle: "Edit User",
    onSuccess: () => fetchUserData(getUserData._id),
  };

  const propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const handleOnChange = (name, value) => {
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSifarishPoint = async () => {
    const payload = {
      userId: getUserData?._id,
      userIdToFetch: UserData?._id,
      points: formValue?.points,
      type: "ADMIN_BONUS",
    };
    const response = await addSifarishPoints(payload);
    if (response?.status === 1) {
      toast.success(response?.message);
      setIsDelete(false);
      fetchUserData();
    } else {
      toast.success(response?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const exportToCSV = async () => {
    try {
      const userListPayload = {
        userId: getUserData?._id,
        userIdToRetrive: id,
      };

      const userListResponse = await getUserDetails(userListPayload);
      const user = userListResponse?.data;

      if (!user || !user._id) {
        toast.error("No user data to export!");
        return;
      }

      const userFormatted = {
        "First Name": user.firstName || "-",
        "Last Name": user.lastName || "-",
        "Bird Name": user.birdId?.title || "-",
        "Phone No.": user.phoneNumber
          ? `${user.countryCode} ${user.phoneNumber}`
          : "-",
        Email: user.email || "-",
        Status: user.isActive ? "Active" : "Inactive",
        Generation: user?.generationId?.title || "-",
        "Sifarish Score": user?.sifarishScore || "-",
        "Sifarish Created": user?.totalSifarishCreatedByUser || "-",
        "Sifarish Forwarded": user?.totalSifarishForwardedByUser || "-",
        "Sifarish Saved": user?.totalSifarishSavedByUser || "-",
        "Sifarish Saved By Others": user?.totalUserSifarishSavedByOthers || "-",
        "Profile URL": user?.userProfileImageUrl || "-",
        "Joined Date": formatDateToDDMMYYYY(user?.createdAt) || "-",
        "Number Verified": user.isPhoneVerified ? "Yes" : "No",
        "Email Verified": user.isEmailVerified ? "Yes" : "No",
        Role: user?.userRole === 2 ? "Admin" : "User",
      };

      const sifarishPayload = {
        userId: getUserData?._id || "",
        userIdToFetch: user._id || "",
        categoryIds: "",
        subCategoryId: "",
        birdId: user?.birdId?._id || "",
        city: user?.city || "",
        state: user?.state || "",
        country: user?.country || "",
        sortBy: "",
        showOnlyPublic: "",
        activeStatus: "",
      };

      const sifarishResponse = await getUserCompleteSifarishData(
        sifarishPayload
      );

      if (!sifarishResponse || !sifarishResponse.data?.sifarishes?.length) {
        toast.error("No sifarish data to export!");
        // return;
      }

      const sifarishData = sifarishResponse?.data?.sifarishes?.map(
        (item, index) => ({
          "Serial No": index + 1,
          Name: `${item?.createdByUserId?.firstName || "-"} ${item?.createdByUserId?.lastName || "-"
            }`,
          Title: item.title || "-",
          Description: item.description || "-",
          Category: item?.categoryId?.title || "-",
          "Sub Category":
            item?.categoryId?.subCategories
              ?.map((sub) => sub.title)
              .join(", ") || "No Subcategories Available",
          "Sifarish Image":
            item.mediaUrls?.length > 0
              ? item.mediaUrls[0]?.url
              : "No Image Available",
          City: item?.address?.city || "-",
          State: item?.address?.state || "-",
          Country: item?.address?.country || "-",
        })
      );

      const wb = XLSX.utils.book_new();

      const userArray = [
        ["Title", "Value"],
        ["", ""],
      ];
      for (const key in userFormatted) {
        userArray.push([key, userFormatted[key]]);
      }
      const userSheet = XLSX.utils.aoa_to_sheet(userArray);

      const sifarishSheet = XLSX.utils.json_to_sheet(sifarishData);

      userSheet["!cols"] = [{ wch: 25 }, { wch: 60 }];

      sifarishSheet["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 40 },
        { wch: 60 },
        { wch: 25 },
        { wch: 40 },
        { wch: 40 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, userSheet, "User Detail");
      XLSX.utils.book_append_sheet(wb, sifarishSheet, "Sifarish Data");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const epochTime = Date.now();
      saveAs(blob, `User_Details_${epochTime}.xlsx`);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const propsAddCategory = {
    // ...props,
    // onSubmit: handleClick,
    // submitLoading: loading,
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Add Sifarish Point",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: handleAddSifarishPoint,
  };

  const exportSavedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: getUserData?._id,
        userIdToRetrive: UserData?._id,
        page: 1,
        limit: -1,
      };

      const res = await getExportSavedSifarish(payload);

      if (
        !res ||
        !res.data?.savedSifarishes ||
        res.data.savedSifarishes.length === 0
      ) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.savedSifarishes;

      const formattedData = fullData.map((item, index) => ({
        "Serial No": index + 1,
        User: `${item?.sifarishId?.createdByUserId?.firstName || "-"} ${item?.sifarishId?.createdByUserId?.lastName || "-"
          }`,
        // "User who saved": `${item?.fromUserId?.firstName || "-"} ${
        //   item?.fromUserId?.lastName || "-"
        // }`,
        // Bird: item?.sifarishId?.birdId?.title || "-",
        Bird: item?.sifarishId?.birdId?.title || "-",
        "User who saved": `${item?.fromUserId?.firstName || "-"} ${item?.fromUserId?.lastName || "-"
          }`,
        "Saved User Bird":
          storageBird?.find((opt) => opt._id === item?.fromUserId?.birdId)
            ?.title || "-",
        Title: item?.sifarishId?.title || "-",
        Category: item?.sifarishId?.categoryId?.title || "-",
        SubCategories:
          item?.sifarishId?.categoryId?.subCategories?.length > 0
            ? item?.sifarishId?.categoryId?.subCategories
              ?.filter((sub) => sub?._id === item?.sifarishId?.subCategoryId)
              ?.map((sub) => sub.title)
              ?.join(", ")
            : "No Subcategories Available",
        Recommended: item?.isRecommended ? "Yes" : "No",
        "Sifarish Image":
          item.sifarishId?.mediaUrls?.length > 0
            ? item?.sifarishId?.mediaUrls[0]?.url
            : "No Image Available",
        City: item?.sifarishId?.address?.city || "-",
        State: item?.sifarishId?.address?.state || "-",
        Country: item?.sifarishId?.address?.country || "-",
      }));

      const wb = XLSX.utils.book_new();

      const ws = XLSX.utils.json_to_sheet(formattedData);

      ws["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 50 },
        { wch: 20 },
        { wch: 35 },
        { wch: 10 },
        { wch: 40 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Saved Sifarish");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });

      const epochTime = Date.now();
      saveAs(blob, `Saved_Sifarish_List_${epochTime}.xlsx`);

      toast.success("Saved Sifarish exported successfully!");
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportForwardSifarishToCSV = async () => {
    try {
      const payload = {
        userId: getUserData?._id,
        userIdToRetrive: UserData?._id,
        page: 1,
        limit: -1,
      };

      const res = await getExportForwardedSifarish(payload);

      if (
        !res ||
        !res.data?.forwardedSifarishes ||
        res.data.forwardedSifarishes.length === 0
      ) {
        toast.error("No forwarded sifarishes found.");
        return;
      }

      const fullData = res.data.forwardedSifarishes;

      const formattedData = fullData.map((item, index) => ({
        "Serial No": index + 1,
        User: `${item?.sifarishId?.createdByUserId?.firstName || "-"} ${item?.sifarishId?.createdByUserId?.lastName || "-"
          }`,
        "User who Forwarded": `${item?.fromUserId?.firstName || "-"} ${item?.fromUserId?.lastName || "-"
          }`,
        Bird: item?.sifarishId?.birdId?.title || "-",
        Title: item?.sifarishId?.title || "-",
        Category: item?.sifarishId?.categoryId?.title || "-",
        SubCategories:
          item?.sifarishId?.categoryId?.subCategories?.length > 0
            ? item?.sifarishId?.categoryId?.subCategories
              ?.filter((sub) => sub?._id === item?.sifarishId?.subCategoryId)
              ?.map((sub) => sub.title)
              ?.join(", ")
            : "No Subcategories Available",
        Recommended: item?.isRecommended ? "Yes" : "No",
        "Sifarish Image":
          item?.sifarishId?.mediaUrls?.length > 0
            ? item?.sifarishId?.mediaUrls[0]?.url
            : "No Image Available",
        City: item?.sifarishId?.address?.city || "-",
        State: item?.sifarishId?.address?.state || "-",
        Country: item?.sifarishId?.address?.country || "-",
      }));

      const wb = XLSX.utils.book_new();

      const ws = XLSX.utils.json_to_sheet(formattedData);

      ws["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 50 },
        { wch: 20 },
        { wch: 35 },
        { wch: 10 },
        { wch: 40 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Forwarded Sifarish");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });

      const epochTime = Date.now();
      saveAs(blob, `Forwarded_Sifarish_List_${epochTime}.xlsx`);

      toast.success("Forwarded Sifarish exported successfully!");
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportReportedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: getUserData?._id,
        userIdWhoReported: UserData?._id,
        page: 1,
        limit: -1,
        showReportedOnly: true,
      };

      const res = await getExportReportedSifarish(payload);

      if (!res || !res.data?.sifarishes || res.data.sifarishes.length === 0) {
        toast.error("No reported sifarishes found.");
        return;
      }

      const fullData = res.data.sifarishes;

      const formattedData = fullData.map((item, index) => ({
        "Serial No": index + 1,
        User: `${item?.createdByUserId?.firstName || "-"} ${item?.createdByUserId?.lastName || "-"
          }`,
        "User who reported": `${UserData?.firstName || "-"} ${UserData?.lastName || "-"
          }`,
        Bird: item?.birdId?.title || "-",
        Title: item?.title || "-",
        Category: item?.categoryId?.title || "-",
        SubCategories:
          item?.categoryId?.subCategories?.length > 0
            ? item?.categoryId?.subCategories
              ?.filter((sub) => sub?._id === item?.subCategoryId)
              ?.map((sub) => sub.title)
              ?.join(", ")
            : "No Subcategories Available",
        "Sifarish Image":
          item?.mediaUrls?.length > 0
            ? item?.mediaUrls[0]?.url
            : "No Image Available",
        City: item?.address?.city || "-",
        State: item?.address?.state || "-",
        Country: item?.address?.country || "-",
      }));

      const wb = XLSX.utils.book_new();

      const ws = XLSX.utils.json_to_sheet(formattedData);

      ws["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 50 },
        { wch: 20 },
        { wch: 35 },
        { wch: 40 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Reported Sifarish");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });

      const epochTime = Date.now();
      saveAs(blob, `Reported_Sifarish_List_${epochTime}.xlsx`);

      toast.success("Reported Sifarish exported successfully!");
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <React.Fragment>
      <ButtonHeading
        title={"User Details"}
        Export={true}
        ExportSubmit={exportToCSV}
        isShow={{
          isAddSifarish: true,
          isActiveUser: true,
          isBackButton: true,
        }}
        handleBackButton={() => handleBackButton()}
        handleActiveFunction={() => fetchToggleUserStatus(UserData?._id)}
        handleAddSifarish={() => setIsDelete(true)}
        activeTitleTxt={`Change to ${UserData?.isActive ? "Inactive" : "Active"
          }`}
        addSifarishTitle="Add Sifarish Point"
      />

      <div className="d-flex justify-content-between px-3 mt-3">
        <button
          disabled={!listData || activeIndex === 0}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev - 1)}
        >
          ⬅ Previous
        </button>

        <button
          disabled={!listData || activeIndex === (listData?.length ?? 1) - 1}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev + 1)}
        >
          Next ➜
        </button>
      </div>

      <div className=" mt-3">
        {UserData ? (
          <>
            <div className="card-body">
              <div className="__userView pb-3">
                <div className="mb-2">
                  <img
                    src={UserData?.userProfileImageUrl || Images.USERLIMG}
                    alt="user Img"
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                    width={60}
                    height={60}
                  />
                </div>

                <div>
                  <h4>
                    {UserData?.firstName} {UserData?.lastName}
                  </h4>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>{UserData?.email} </p>{" "}
                  {UserData?.isEmailVerified ? (
                    <span className="_verifyMail">Verify</span>
                  ) : (
                    <MdCancel style={{ color: "#d62727" }} />
                  )}
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>{UserData?.phoneNumber} </p>
                  {UserData?.isPhoneVerified ? (
                    <div style={{ color: "#08B231", fontSize: "14px" }}>
                      <FaCheckCircle />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {UserData?.birdId ? (
                  <div className="__birdTag">
                    <div className="__birdTag_imgbx">
                      <img
                        src={UserData?.birdId?.imageUrl}
                        alt={UserData?.birdId?.title}
                      />
                    </div>
                    <span>{UserData?.birdId?.title}</span>
                  </div>
                ) : (
                  ""
                )}

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>Sifarish Score </p>{" "}
                  <span style={{ color: "#001b50" }}>
                    <FaMedal />
                  </span>{" "}
                  <p>{UserData?.sifarishPoints || 0}</p>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>Location :</p>{" "}
                  <p>
                    {`${UserData?.city || "-"}, ${UserData?.state || "-"}, ${UserData?.country || "-"
                      }`}
                  </p>
                </div>

                <div className="__staTics">
                  <h5>Statistics</h5>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>Created</h6>
                    <p>{UserData?.totalSifarishCreatedByUser}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>Helpful</h6>
                    <p>{UserData?.totalUserSifarishSavedByOthers}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>Forwarded</h6>
                    <p>{UserData?.totalSifarishForwardedByUser}</p>
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>
                    Joined:{" "}
                    <span style={{ color: "#001b50" }}>
                      {" "}
                      {new Date(UserData?.createdAt).toLocaleDateString()}
                    </span>{" "}
                  </p>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>
                    Generation Title:{" "}
                    <span style={{ color: "#001b50" }}>
                      {" "}
                      {UserData?.generationId?.title}
                    </span>{" "}
                  </p>
                </div>

                <div className="d-flex mt-1 gap-2">
                  <button
                    onClick={(e) => navigateOnSifarish(e)}
                    className="__birdTag "
                  >
                    {" "}
                    View All Sifarish
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => navigateOnSession(UserData)}
                  >
                    View All Sessions
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => navigateOnContact(UserData)}
                  >
                    View All Contact
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => navigateOnSifarishPoint(UserData)}
                  >
                    View Sifarish Point
                  </button>
                </div>

                <div className="d-flex mt-1 gap-2">
                  <button
                    onClick={() => exportSavedSifarishToCSV()}
                    className="__birdTag "
                  >
                    Export Saved Sifarish
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportForwardSifarishToCSV()}
                  >
                    Export Forwarded Sifarish
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportReportedSifarishToCSV()}
                  >
                    Export Reported Sifarish
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <p>Loading User Details...</p>
        )}
      </div>

      {isOpen && userToEdit && (
        <EditUserProfile
          userId={getUserData?._id}
          userIdToUpdate={userToEdit._id}
          userData={userToEdit}
          props={EditUserModal}
        />
      )}

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3">
            {" "}
            Are you sure to delete {isDelete?.firstName} {isDelete?.lastName}?
          </p>
        </CommonModal>
      )}

      <CommonModal {...propsAddCategory}>
        <div className="addLr_body">
          <div className="_allDflx">
            <div>
              <CommonInput
                type="number"
                placeholder="Points"
                label="Points*"
                name="points"
                value={formValue.points}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
              />
            </div>
          </div>
        </div>
      </CommonModal>
    </React.Fragment>
  );
};

export default UserDetails;
